import { useMemo, useRef } from 'react'
import { useQuery } from 'react-query'
import { sectionsQueryData, SectionsResponse } from 'src/api'
import { Section } from 'src/types/entities'
import { mapBackendSections } from 'src/utils'

type FetchSectionsResult = {
  sectionsError: unknown,
  isSectionsFetching: boolean,
  sections: Section[] | undefined,
  sectionsResponse: SectionsResponse | undefined,
}

const useFetchSections = (categoryId: string): FetchSectionsResult => {
  const {
    error: sectionsError,
    data: sectionsResponse,
    isLoading: isSectionsFetching,
  } = useQuery<SectionsResponse>(
    [sectionsQueryData.key, categoryId],
    () => sectionsQueryData.fetch(categoryId),
  )
  const mappingError = useRef<null | unknown>(null)

  const sections = useMemo(() => {
    try {
      const backendSections = sectionsResponse?.sections

      return backendSections && mapBackendSections(backendSections)
    } catch (e) {
      mappingError.current = e

      return []
    }
  }, [sectionsResponse])

  return {
    sectionsError: mappingError.current || sectionsError,
    isSectionsFetching,
    sections,
    sectionsResponse: mappingError.current ? undefined : sectionsResponse,
  }
}

export { useFetchSections }
export type { FetchSectionsResult }
